<template>
	<div>
		<BrandCategoryAdd @getList="getList" />
		<BrandCategoryList ref="brandCategoryList" />
	</div>
</template>
<script>
	import BrandCategoryAdd from '../../components/brand/BrandCategoryAdd.vue';
	import BrandCategoryList from '../../components/brand/BrandCategoryList.vue';

	export default {
		components: {
			BrandCategoryAdd,
			BrandCategoryList,
		},
		data() {
			return {};
		},
		methods: {
			getList() {
				this.$refs.brandCategoryList.getList();
			},
		},
	};
</script>
<style lang="scss" scoped></style>
